import { useState } from "react";
import { Modal } from "../interface/Modal";

const useModalVisibility = (modal: Modal) => {
  const [modalProperties, setModalProperties] = useState(modal);
  return { modalProperties, setModalProperties };
};

export default useModalVisibility;
